var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1296_35116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8.048C16.0003 6.51909 15.5625 5.0221 14.7385 3.73428C13.9144 2.44646 12.7385 1.42176 11.3501 0.781507C9.96173 0.14125 8.41893 -0.0877455 6.90442 0.121635C5.38991 0.331015 3.96712 0.970001 2.80451 1.96293C1.6419 2.95587 0.788165 4.26116 0.344396 5.72425C-0.0993733 7.18735 -0.114591 8.74697 0.300544 10.2184C0.71568 11.6899 1.54378 13.0116 2.68679 14.0271C3.82981 15.0425 5.23986 15.7091 6.75 15.948V10.36H4.719V8.048H6.75V6.285C6.70627 5.87345 6.7536 5.45732 6.88863 5.0661C7.02366 4.67487 7.24309 4.31814 7.53136 4.02118C7.81964 3.72423 8.1697 3.49431 8.55674 3.34773C8.94379 3.20115 9.35833 3.1415 9.771 3.173C10.371 3.18088 10.9696 3.23303 11.562 3.329V5.3H10.554C10.3823 5.27755 10.2077 5.29399 10.0432 5.34812C9.87874 5.40224 9.72853 5.49266 9.6037 5.61269C9.47887 5.73272 9.38263 5.87927 9.3221 6.04152C9.26157 6.20376 9.23829 6.37755 9.254 6.55V8.05H11.473L11.118 10.362H9.25V15.953C11.1322 15.6552 12.8464 14.6954 14.0838 13.2462C15.3213 11.797 16.0008 9.95364 16 8.048Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1296_35116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0f602d92.svg";
export { ForwardRef as ReactComponent };